module.exports = __webpack_public_path__ + "static/logo-9a43d19ab4c6192531bbde2419e8ea8c.png";